<rappider-crud-view-edit-form [config]="dataSchemaFormConfig"
                              [data]="data"
                              [submitButtonLoading]="submitButtonLoading"
                              (formSubmit)="onDataSchemaFormSubmit($event)"></rappider-crud-view-edit-form>